import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { OrderStateMap } from './order.model';
import { initialOrderMap } from './order.model';

export function orderReducer(state: OrderStateMap = initialOrderMap, action: Action): OrderStateMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_REQUESTED':
      return addOrReplaceKey(state, action.tabId, { status: 'PENDING' });
    case 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_RECEIVED':
      return patchKey(state, action.tabId, _ => ({
        status: 'DONE' as const,
        execTime: action.execTime,
        orderId: action.orderId,
      }));
    case 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_STALE':
      return patchKey(state, action.tabId, _ => ({
        status: 'STALE' as const,
      }));
    case 'SECONDARY_MARKET_DLP_ORDER_PLACEMENT_FAILED':
      return addOrReplaceKey(state, action.tabId, {
        status: 'REJECTED',
        errorMessage: action.errorMessage,
        timeout: action.timeout,
        isTimeout: action.isTimeout,
        rejections: action.rejections,
        orderId: action.orderId,
      });
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'WORKSPACE_TABS_ALL_REMOVED':
      if (action.workspace === 'secondaryMarketQuotes') {
        return initialOrderMap;
      } else {
        return state;
      }
    case 'SECONDARY_MARKET_DLP_ORDER_CLOSE':
      return removeKey(state, action.tabId);
    default:
      return state;
  }
}
